/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft Registration`)
};

const zh_hans1_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 注册`)
};

const zh_hant1_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 註冊`)
};

const fr_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription Minecraft`)
};

const de_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Registrierung`)
};

const ja_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 登録`)
};

const ko_register_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 등록`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_minecraft_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_minecraft_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_minecraft_title", locale)
	if (locale === "en") return en_register_minecraft_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_minecraft_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_minecraft_title(inputs)
	if (locale === "fr") return fr_register_minecraft_title(inputs)
	if (locale === "de") return de_register_minecraft_title(inputs)
	if (locale === "ja") return ja_register_minecraft_title(inputs)
	return ko_register_minecraft_title(inputs)
};